import React, { ReactElement, useEffect, useState } from 'react';
import LoadingPage from './LoadingPage';
import LogoPage from './LogoPage';
import CheckboxControl from './CheckboxControl';
import api from '../helpers/api';
import { UserContextSummary } from '../models/dto/userContext';
import authProvider from '../helpers/authProvider';

export default function Tos(props: Props) {
	const [initialized, setInitialized] = useState<boolean>(false);
	const [accepted, setAccepted] = useState<boolean>(false);
	const [requestInProgress, setRequestInProgress] = useState<boolean>(false);
	const [state, setState] = useState<'loading' | 'terms' | 'accepted' | 'error'>('loading');
	
	useEffect(() => {
		// this is probably not necessary but not sure that there
		// is a 100% guarantee that this will only ever run once
		if (initialized) return;
		
		setInitialized(true);
		
		const request = authProvider.getUserContextPromise();
		if (request) {
			request.then(context => {
				if (context.hasAcceptedTerms) {
					setState('accepted');
				} else {
					setState('terms');
				}
			}, () => {
				setState('error');
			});
		} else {
			// this should never happen because we authenticate before getting
			// here (this component should always be inside the Auth component)
			setState('error');
		}
	}, []);
	
	if (state === 'accepted') {
		return props.children;
	} else if (state === 'terms') {
		return (
			<LogoPage>
				<React.Fragment>
					<div className="text-center text-bold mb-4">One thing before you get started:</div>
					<div className="text-center mb-5">
						<div className="ib">
							<CheckboxControl checked={accepted} onClick={onAcceptedClicked}>
								<span>I have read and agree to Creovai's <a href="https://tethr.com/terms/" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://tethr.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</span>
							</CheckboxControl>
						</div>
					</div>
					<div className="text-center">
						<button className="btn btn_wide" disabled={!accepted || requestInProgress} onClick={onContinue}>Continue</button>
					</div>
				</React.Fragment>
			</LogoPage>
		);
	} else if (state === 'error') {
		return (
			<LogoPage>
				<div className="text-center">Something went wrong. Please refresh the page.</div>
			</LogoPage>
		);
	} else {
		return <LoadingPage />;
	}
	
	function onAcceptedClicked(): void {
		setAccepted(prev => !prev);
	}
	
	function onContinue(): void {
		if (!accepted || requestInProgress) return;
		
		setRequestInProgress(true);
		
		api.put<UserContextSummary>('/api/context/accept-tos').then(() => {
			setState('accepted');
			setRequestInProgress(false);
		}, () => {
			setRequestInProgress(false);
		});
	}
}

interface Props {
    children: ReactElement;
}
